var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
export var ThreadAvatar = function (_a) {
    var firstName = _a.firstName, lastName = _a.lastName;
    var initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase();
    return (_jsx(React.Fragment, { children: _jsx("div", __assign({ className: "post-avatar-col" }, { children: _jsx("div", __assign({ className: "post-avatar" }, { children: initials })) })) }));
};
